exports.name = 'Job';

exports.types = [
  'string', 'object', 'boolean', 'array', 'number', 'date'
];

exports.syskeys = [];

exports.fields = {
  name: 'string',
  dateAt: 'date',
  data: 'object',
}
